export const en = {
  categoryCoverageWasNotRecordedForThisReportVersionMissing:
    'Category coverage was not recorded for this report version. Missing findings do not establish clearance.',
  noSummaryIsAvailable: 'No summary is available.',
  identityContext: 'Identity Context',
  sanctionsWatchlists: 'Sanctions & Watchlists',
  pepExposure: 'PEP Exposure',
  professionalBackground: 'Professional Background',
  sanctions: 'Sanctions',
  social: 'Social',
  explainYourReview: 'Explain your review.',
  legacySeverity: 'Legacy severity',
  notProvided: 'Not provided',
  noEvidenceSummaryAvailable: 'No evidence summary available.',
  countryOfResidence: 'Country of Residence',
  accountUse: 'Account Use',
  netWorth: 'Net Worth',
  registrationNumber: 'Registration Number',
  companyId: 'Company ID',
  incorporationDate: 'Incorporation Date',
  registeredAddress: 'Registered Address',
  annualRevenue: 'Annual Revenue',
  ultimateBeneficialOwners: 'Ultimate Beneficial Owners',
  contactEmail: 'Contact Email',
  contactPhone: 'Contact Phone',
  estimatedNetWorth: 'Estimated Net Worth',
  explainYourDecision: 'Explain your decision.',
  researchHasNotProducedAnAssessmentYet: 'Research has not produced an assessment yet.',
  document: 'Document',
  clipboardNotSupported: 'Clipboard not supported',
  copyFailed: 'Copy failed',
  noReviewSummaryRecorded: 'No review summary recorded.',
  noPreviousPeriodComparison: 'No previous-period comparison',
  viewReports: 'View Reports',
  viewClients: 'View Clients',
  youLlBeNotified: 'You’ll be notified.',
  reviewAndDecide: 'Review and decide.',
  negativeSentimentSpikes: 'Negative sentiment spikes',
  influencerMentionsSurge: 'Influencer mentions surge',
  hidingAffiliationDetected: 'Hiding affiliation detected',
  weakAmlEnforcement: 'Weak AML enforcement',
  highCorruptionIndex: 'High corruption index',
  fraudAllegationsFound: 'Fraud allegations found',
  courtCaseMentioned: 'Court case mentioned',
  whistleblowerReportPublished: 'Whistleblower report published',
  relativeIsPep: 'Relative is PEP',
  businessPartnerPolitician: 'Business partner politician',
  buildDashboard: 'Build Dashboard',
  buildIntake: 'Build Intake',
  buildWorkspace: 'Build Workspace',
  buildLaunch: 'Build Launch',
  smartKycKyb: 'Smart KYC & KYB',
  reportGeneration: 'Report Generation',
  complianceInsights: 'Compliance Insights',
  teamCollaboration: 'Team Collaboration',
  verifyClientsWithAiPoweredDataExtractionAndValidationFrom:
    'Verify clients with AI-powered data extraction and validation from official documents.',
  uploadAnyClientDocumentAndAutomaticallyExtractStructureAndValidate:
    'Upload any client document and automatically extract, structure and validate key data.',
  aggregateAndAnalyzeClientDataFromWebSourcesAndSensitive:
    'Aggregate and analyze client data from web sources and sensitive databases.',
  identifyRiskSignalsAutomaticallyAndGenerateAClearStructuredRisk:
    'Identify risk signals automatically and generate a clear, structured risk score.',
  createStructuredAuditReadyComplianceReportsBasedOnEnrichedData:
    'Create structured, audit-ready compliance reports based on enriched data, research, and risk scoring.',
  monitorClientRiskOverTimeAndGenerateUpdatedComplianceReports:
    'Monitor client risk over time and generate updated compliance reports on every change.',
  expert: 'Expert',
  secure: 'Secure',
  simple: 'Simple',
  scalable: 'Scalable',
  swift: 'Swift',
  humanCentric: 'Human-centric',
  traceable: 'Traceable',
  detectingSocialSignals: 'Detecting social signals ...',
  assessingJurisdictionRisk: 'Assessing jurisdiction risk ...',
  scanningForAdverseMedia: 'Scanning for adverse media...',
  checkingPepExposure: 'Checking PEP exposure ...',
  searchingGlobalWatchlists: 'Searching global watchlists ...',
  defineCustomRolesAndControlAccessLevelsForEveryTeam:
    'Define custom roles and control access levels for every team member.',
  trackClientsDataReportsAndTeamActivityAllInOne:
    'Track clients, data, reports, and team activity—all in one place.',
  accessWellOrganizedClientProfilesReportsAndForSearchAnd:
    'Access well-organized client profiles, reports, and for search and monitoring.',
  cryptoExchangeBerlin: 'Crypto Exchange, Berlin',
  weDonTWorryAboutKycAnymoreRavenDoesIt:
    "We don't worry about KYC anymore. Raven does it for us. From ID checks to sanctions lists, it's all automatic. Our team saves hours every week, and we know every client is screened thoroughly. Raven is like adding an entire compliance team overnight.",
  headOfCompliance: 'Head of Compliance',
  neobankAmsterdam: 'Neobank, Amsterdam',
  fintechDubai: 'Fintech, Dubai',
  riskManager: 'Risk Manager',
  governmentInstitutionParis: 'Government Institution, Paris',
  cryptoExchangeLondon: 'Crypto Exchange, London',
  areYouSureYouWantToRejectAValidDocument: 'Are you sure you want to reject a valid document?',
  rejectDocument: 'Reject Document',
  areYouSureYouWantToAcceptAFlaggedDocument: 'Are you sure you want to accept a Flagged Document?',
  acceptDocument: 'Accept Document',
  areYouSureYouWantToDeleteThisUploadedDocument:
    'Are you sure you want to delete this uploaded document?',
  deleteDocument: 'Delete Document',
  areYouSureYouWantToDeleteThisMember: 'Are you sure you want to delete this member?',
  deleteMember: 'Delete Member',
  areYouSureYouWantToAddThisHighRisk: 'Are you sure you want to add this high-risk client?',
  addClient: 'Add Client',
  areYouSureYouWantToRejectThisVerifiedLow:
    'Are you sure you want to reject this verified low-risk client?',
  rejectClient: 'Reject Client',
  areYouSureYouWantToDeleteThisNote: 'Are you sure you want to delete this note?',
  deleteNote: 'Delete Note',
  areYouSureYouWantToDismissThisSignal: 'Are you sure you want to dismiss this signal?',
  dismissSignal: 'Dismiss signal',
  uploadCompanyDocs: 'Upload company docs',
  additionalDocuments: 'Additional documents',
  companyForm: 'Company form',
  uploadClientId: 'Upload client ID',
  completeClientForm: 'Complete client form',
  leaveAnyway: 'Leave anyway',
  additionalDocument: 'Additional document',
  frontSide: 'Front side',
  backSide: 'Back side',
  addAtLeastOneKeyMember: 'Add at least one key member',
  youCannotUploadDocumentsAtThisTime: 'You cannot upload documents at this time.',
  youHaveReachedYourDocumentLimit: 'You have reached your document limit.',
  addADocument: 'Add a document',
  uploadDocument: 'Upload Document',
  politicalExposurePep: 'Political Exposure (PEP)',
  anAssessmentHasNotBeenGenerated: 'An assessment has not been generated.',
  occupation: 'Occupation',
  writeANoteFirst: 'Write a note first.',
  enter: 'Enter',
  appearance: 'Appearance',
  unableToCopyTheToken: 'Unable to copy the token',
  youDoNotHavePermissionToCreateATokenFor:
    'You do not have permission to create a token for this organization.',
  somethingWentWrongPleaseTryAgainLater: 'Something went wrong. Please try again later.',
  thisAccountHasBeenDisabledPleaseContactSupport:
    'This account has been disabled. Please contact support.',
  thisPasskeyIsNotConfiguredForThisApplicationPleaseLogin:
    'This passkey is not configured for this application. Please login and add one in the user settings.',
  thisSessionHasExpiredPleaseTryAgain: 'This session has expired. Please try again.',
  theEmailOrPasswordProvidedIsIncorrect: 'The email or password provided is incorrect.',
  theTwoFactorAuthenticationCodeProvidedIsIncorrect:
    'The two-factor authentication code provided is incorrect.',
  signupIsCurrentlyDisabledOrNotAvailableForYourEmail:
    'Signup is currently disabled or not available for your email domain.',
  userWithThisEmailAlreadyExistsPleaseUseADifferent:
    'User with this email already exists. Please use a different email address.',
  weWereUnableToCreateYourAccountPleaseReviewThe:
    'We were unable to create your account. Please review the information you provided and try again.',
  userHasNoPassword: 'User has no password.',
  currentPasswordIsIncorrect: 'Current password is incorrect.',
  yourNewPasswordCannotBeTheSameAsYourOld:
    'Your new password cannot be the same as your old password.',
  weEncounteredAnUnknownErrorWhileAttemptingToUpdateYour:
    'We encountered an unknown error while attempting to update your password. Please try again later.',
  tokenHasExpiredPleaseTryAgain: 'Token has expired. Please try again.',
  invalidTokenProvidedPleaseTryAgain: 'Invalid token provided. Please try again.',
  weEncounteredAnUnknownErrorWhileAttemptingToResetYour:
    'We encountered an unknown error while attempting to reset your password. Please try again later.',
  invalidEmailAddress: 'Invalid email address',
  emailIsRequired: 'Email is required',
  allowsTheOfficerToViewAllClientsInTheOrganization:
    'Allows the officer to view all clients in the organization.',
  allowsTheOfficerToViewAllReportsCreatedByOther:
    'Allows the officer to view all reports created by other officers within the organization.',
  allowsTheOfficerToApproveOrRejectClientsBasedReport:
    'Allows the officer to approve or reject clients based report results.',
  allowsTheOfficerToCreateBothKycAndKybReports:
    'Allows the officer to create both KYC and KYB reports to review clients.',
  allowsTheOfficerToViewAndManageOnlyReportsThey:
    'Allows the officer to view and manage only reports they have created themselves.',
  allowsTheOfficerToViewAndManageOnlyClientsThey:
    'Allows the officer to view and manage only clients they have added themselves.',
  allowsTheOfficerToApproveOrRejectClientsBasedCreated:
    'Allows the officer to approve or reject clients based created report results.',
  allowsTheOfficerToCreateBothKycReportsToReview:
    'Allows the officer to create both KYC reports to review clients.',
  allowsTheOfficerToCreateKybReportsToReviewClients:
    'Allows the officer to create KYB reports to review clients.',
  manager: 'Manager',
  never: 'Never',
  pleaseConfirmYourPassword: 'Please confirm your password',
  dismiss: 'Dismiss',
  proceed: 'Proceed',
  search: 'Search...',
  previous: 'Previous',
  next: 'Next',
  none: 'None',
  commandPalette: 'Command Palette',
  searchForACommandToRun: 'Search for a command to run...',
} as const;
export const fa: Record<keyof typeof en, string> = {
  categoryCoverageWasNotRecordedForThisReportVersionMissing:
    'پوشش بررسی برای این نسخه از گزارش ثبت نشده است. نبود یافته به معنی نبود ریسک نیست.',
  noSummaryIsAvailable: 'خلاصه‌ای در دسترس نیست.',
  identityContext: 'اطلاعات هویتی',
  sanctionsWatchlists: 'تحریم‌ها و فهرست‌های نظارتی',
  pepExposure: 'ارتباطات سیاسی',
  professionalBackground: 'سوابق حرفه‌ای',
  sanctions: 'تحریم‌ها',
  social: 'اجتماعی',
  explainYourReview: 'دلیل بررسی خود را بنویسید.',
  legacySeverity: 'شدت ثبت‌شده در نسخه قبلی',
  notProvided: 'وارد نشده',
  noEvidenceSummaryAvailable: 'خلاصه شواهد در دسترس نیست.',
  countryOfResidence: 'کشور محل اقامت',
  accountUse: 'هدف استفاده از حساب',
  netWorth: 'خالص دارایی',
  registrationNumber: 'شماره ثبت',
  companyId: 'شناسه شرکت',
  incorporationDate: 'تاریخ تأسیس',
  registeredAddress: 'نشانی ثبتی',
  annualRevenue: 'درآمد سالانه',
  ultimateBeneficialOwners: 'مالکان نهایی',
  contactEmail: 'ایمیل تماس',
  contactPhone: 'تلفن تماس',
  estimatedNetWorth: 'برآورد خالص دارایی',
  explainYourDecision: 'دلیل تصمیم خود را بنویسید.',
  researchHasNotProducedAnAssessmentYet: 'هنوز ارزیابی آماده نشده است.',
  document: 'مدرک',
  clipboardNotSupported: 'مرورگر از کپی پشتیبانی نمی‌کند',
  copyFailed: 'کپی انجام نشد',
  noReviewSummaryRecorded: 'خلاصه بررسی ثبت نشده است.',
  noPreviousPeriodComparison: 'اطلاعات دوره قبل موجود نیست',
  viewReports: 'مشاهده گزارش‌ها',
  viewClients: 'مشاهده مشتریان',
  youLlBeNotified: 'به شما اطلاع داده می‌شود.',
  reviewAndDecide: 'بررسی و تصمیم‌گیری کنید.',
  negativeSentimentSpikes: 'افزایش واکنش‌های منفی',
  influencerMentionsSurge: 'افزایش اشاره‌های افراد تأثیرگذار',
  hidingAffiliationDetected: 'پنهان کردن وابستگی شناسایی شد',
  weakAmlEnforcement: 'ضعف در اجرای مقررات مبارزه با پول‌شویی',
  highCorruptionIndex: 'شاخص بالای فساد',
  fraudAllegationsFound: 'ادعای کلاهبرداری شناسایی شد',
  courtCaseMentioned: 'اشاره به پرونده قضایی',
  whistleblowerReportPublished: 'انتشار گزارش افشاگری',
  relativeIsPep: 'ارتباط خانوادگی با شخص دارای موقعیت سیاسی',
  businessPartnerPolitician: 'شریک تجاری دارای سمت سیاسی',
  buildDashboard: 'ساخت داشبورد',
  buildIntake: 'ساخت فرم پذیرش',
  buildWorkspace: 'ساخت فضای کاری',
  buildLaunch: 'راه‌اندازی سامانه',
  smartKycKyb: 'شناخت هوشمند مشتری حقیقی و حقوقی',
  reportGeneration: 'تهیه گزارش',
  complianceInsights: 'تحلیل تطبیق مقررات',
  teamCollaboration: 'همکاری تیمی',
  verifyClientsWithAiPoweredDataExtractionAndValidationFrom:
    'احراز هویت مشتری با استخراج و اعتبارسنجی هوشمند اطلاعات مدارک رسمی',
  uploadAnyClientDocumentAndAutomaticallyExtractStructureAndValidate:
    'مدارک مشتری را بارگذاری کنید تا اطلاعات آن‌ها خودکار استخراج، مرتب و اعتبارسنجی شود.',
  aggregateAndAnalyzeClientDataFromWebSourcesAndSensitive:
    'اطلاعات مشتری را از منابع وب و پایگاه‌های مرتبط گردآوری و تحلیل کنید.',
  identifyRiskSignalsAutomaticallyAndGenerateAClearStructuredRisk:
    'نشانه‌های ریسک را خودکار شناسایی و امتیاز ریسک روشن و منظمی دریافت کنید.',
  createStructuredAuditReadyComplianceReportsBasedOnEnrichedData:
    'بر اساس اطلاعات تکمیلی، جست‌وجو و ارزیابی ریسک، گزارش مستند و قابل حسابرسی تهیه کنید.',
  monitorClientRiskOverTimeAndGenerateUpdatedComplianceReports:
    'ریسک مشتری را در طول زمان پایش کنید و با هر تغییر، گزارش به‌روز دریافت کنید.',
  expert: 'تخصص',
  secure: 'امنیت',
  simple: 'سادگی',
  scalable: 'مقیاس‌پذیری',
  swift: 'سرعت',
  humanCentric: 'توجه به نیاز کاربر',
  traceable: 'قابلیت پیگیری',
  detectingSocialSignals: 'در حال بررسی شبکه‌های اجتماعی…',
  assessingJurisdictionRisk: 'در حال ارزیابی ریسک کشور…',
  scanningForAdverseMedia: 'در حال جست‌وجوی اخبار منفی…',
  checkingPepExposure: 'در حال بررسی ارتباطات سیاسی…',
  searchingGlobalWatchlists: 'در حال جست‌وجوی فهرست‌های نظارتی…',
  defineCustomRolesAndControlAccessLevelsForEveryTeam:
    'نقش‌های دلخواه تعریف کنید و دسترسی هر عضو را مشخص کنید.',
  trackClientsDataReportsAndTeamActivityAllInOne:
    'مشتریان، اطلاعات، گزارش‌ها و فعالیت تیم را یکجا دنبال کنید.',
  accessWellOrganizedClientProfilesReportsAndForSearchAnd:
    'پرونده‌ها و گزارش‌های منظم مشتریان را برای جست‌وجو و پایش در اختیار داشته باشید.',
  cryptoExchangeBerlin: 'صرافی رمزارز، برلین',
  weDonTWorryAboutKycAnymoreRavenDoesIt:
    'با Raven، بررسی هویت و فهرست‌های تحریم خودکار انجام می‌شود. تیم ما هر هفته چند ساعت در زمان صرفه‌جویی می‌کند و مطمئن است همه مشتریان دقیق بررسی می‌شوند. انگار یک تیم کامل تطبیق به مجموعه اضافه کرده‌ایم.',
  headOfCompliance: 'مدیر تطبیق مقررات',
  neobankAmsterdam: 'نئوبانک، آمستردام',
  fintechDubai: 'شرکت فناوری مالی، دبی',
  riskManager: 'مدیر ریسک',
  governmentInstitutionParis: 'نهاد دولتی، پاریس',
  cryptoExchangeLondon: 'صرافی رمزارز، لندن',
  areYouSureYouWantToRejectAValidDocument: 'این مدرک معتبر رد شود؟',
  rejectDocument: 'رد مدرک',
  areYouSureYouWantToAcceptAFlaggedDocument: 'این مدرک دارای هشدار تأیید شود؟',
  acceptDocument: 'تأیید مدرک',
  areYouSureYouWantToDeleteThisUploadedDocument: 'این مدرک بارگذاری‌شده حذف شود؟',
  deleteDocument: 'حذف مدرک',
  areYouSureYouWantToDeleteThisMember: 'این عضو حذف شود؟',
  deleteMember: 'حذف عضو',
  areYouSureYouWantToAddThisHighRisk: 'این مشتری با ریسک بالا اضافه شود؟',
  addClient: 'افزودن مشتری',
  areYouSureYouWantToRejectThisVerifiedLow: 'این مشتری تأییدشده با ریسک پایین رد شود؟',
  rejectClient: 'رد مشتری',
  areYouSureYouWantToDeleteThisNote: 'این یادداشت حذف شود؟',
  deleteNote: 'حذف یادداشت',
  areYouSureYouWantToDismissThisSignal: 'این مورد رد شود؟',
  dismissSignal: 'رد مورد',
  uploadCompanyDocs: 'بارگذاری مدارک شرکت',
  additionalDocuments: 'مدارک تکمیلی',
  companyForm: 'اطلاعات شرکت',
  uploadClientId: 'بارگذاری مدرک هویتی',
  completeClientForm: 'تکمیل اطلاعات مشتری',
  leaveAnyway: 'خروج بدون ذخیره',
  additionalDocument: 'مدرک تکمیلی',
  frontSide: 'روی مدرک',
  backSide: 'پشت مدرک',
  addAtLeastOneKeyMember: 'حداقل یک فرد کلیدی اضافه کنید',
  youCannotUploadDocumentsAtThisTime: 'در حال حاضر امکان بارگذاری مدرک وجود ندارد.',
  youHaveReachedYourDocumentLimit: 'به سقف مجاز تعداد مدارک رسیده‌اید.',
  addADocument: 'افزودن مدرک',
  uploadDocument: 'بارگذاری مدرک',
  politicalExposurePep: 'ارتباطات سیاسی (PEP)',
  anAssessmentHasNotBeenGenerated: 'هنوز ارزیابی تهیه نشده است.',
  occupation: 'شغل',
  writeANoteFirst: 'ابتدا یادداشت خود را بنویسید.',
  enter: 'ورود',
  appearance: 'ظاهر برنامه',
  unableToCopyTheToken: 'کلید کپی نشد',
  youDoNotHavePermissionToCreateATokenFor: 'اجازه ایجاد کلید برای این سازمان را ندارید.',
  somethingWentWrongPleaseTryAgainLater: 'مشکلی پیش آمد. کمی بعد دوباره تلاش کنید.',
  thisAccountHasBeenDisabledPleaseContactSupport:
    'این حساب غیرفعال شده است. با پشتیبانی تماس بگیرید.',
  thisPasskeyIsNotConfiguredForThisApplicationPleaseLogin:
    'این کلید عبور برای برنامه ثبت نشده است. وارد شوید و از تنظیمات حساب یک کلید اضافه کنید.',
  thisSessionHasExpiredPleaseTryAgain: 'نشست شما پایان یافته است. دوباره تلاش کنید.',
  theEmailOrPasswordProvidedIsIncorrect: 'ایمیل یا رمز عبور درست نیست.',
  theTwoFactorAuthenticationCodeProvidedIsIncorrect: 'کد احراز هویت دومرحله‌ای درست نیست.',
  signupIsCurrentlyDisabledOrNotAvailableForYourEmail:
    'در حال حاضر ثبت‌نام برای این ایمیل امکان‌پذیر نیست.',
  userWithThisEmailAlreadyExistsPleaseUseADifferent:
    'با این ایمیل قبلاً حسابی ثبت شده است. از ایمیل دیگری استفاده کنید.',
  weWereUnableToCreateYourAccountPleaseReviewThe:
    'ایجاد حساب انجام نشد. اطلاعات را بررسی کنید و دوباره تلاش کنید.',
  userHasNoPassword: 'برای این حساب رمز عبور تعیین نشده است.',
  currentPasswordIsIncorrect: 'رمز عبور فعلی درست نیست.',
  yourNewPasswordCannotBeTheSameAsYourOld: 'رمز عبور جدید باید با رمز قبلی متفاوت باشد.',
  weEncounteredAnUnknownErrorWhileAttemptingToUpdateYour:
    'تغییر رمز عبور انجام نشد. کمی بعد دوباره تلاش کنید.',
  tokenHasExpiredPleaseTryAgain: 'کد منقضی شده است. دوباره تلاش کنید.',
  invalidTokenProvidedPleaseTryAgain: 'کد معتبر نیست. دوباره تلاش کنید.',
  weEncounteredAnUnknownErrorWhileAttemptingToResetYour:
    'بازیابی رمز عبور انجام نشد. کمی بعد دوباره تلاش کنید.',
  invalidEmailAddress: 'آدرس ایمیل معتبر نیست',
  emailIsRequired: 'ایمیل را وارد کنید',
  allowsTheOfficerToViewAllClientsInTheOrganization: 'مشاهده همه مشتریان سازمان',
  allowsTheOfficerToViewAllReportsCreatedByOther:
    'مشاهده گزارش‌های تهیه‌شده توسط دیگر کارشناسان سازمان',
  allowsTheOfficerToApproveOrRejectClientsBasedReport: 'تأیید یا رد مشتریان بر اساس نتایج گزارش',
  allowsTheOfficerToCreateBothKycAndKybReports: 'تهیه گزارش KYC و KYB برای بررسی مشتریان',
  allowsTheOfficerToViewAndManageOnlyReportsThey: 'مشاهده و مدیریت فقط گزارش‌های خود',
  allowsTheOfficerToViewAndManageOnlyClientsThey: 'مشاهده و مدیریت فقط مشتریان ثبت‌شده توسط خود',
  allowsTheOfficerToApproveOrRejectClientsBasedCreated:
    'تأیید یا رد مشتریان بر اساس نتایج گزارش‌های خود',
  allowsTheOfficerToCreateBothKycReportsToReview: 'تهیه گزارش KYC برای بررسی مشتریان حقیقی',
  allowsTheOfficerToCreateKybReportsToReviewClients: 'تهیه گزارش KYB برای بررسی مشتریان حقوقی',
  manager: 'مدیر',
  never: 'هرگز',
  pleaseConfirmYourPassword: 'رمز عبور را تأیید کنید',
  dismiss: 'بستن',
  proceed: 'ادامه',
  search: 'جست‌وجو…',
  previous: 'قبلی',
  next: 'بعدی',
  none: 'هیچ‌کدام',
  commandPalette: 'فهرست فرمان‌ها',
  searchForACommandToRun: 'جست‌وجوی فرمان…',
};
